import React from 'react';

import SmartImage from 'dpl/components/SmartImage';
import { SectionContent } from 'dpl/homepage/components/MobileAppQRSection';

import appDesktopImg from 'dpl/assets/homepage/app_desktop.jpeg';
import appMessengerImg from 'dpl/assets/homepage/app_messenger.png';
import appMobileImg from 'dpl/assets/homepage/app_mobile.png';

export default function BuyerAppQRModule() {
  return (
    <div className="BuyerAppQRModule bg-stone-700">
      {/* mobile */}
      <div className="md:hidden">
        <div className="container-xxl flex justify-center">
          <SmartImage src={appMobileImg} />
        </div>
        <SectionContent className="container-xxl bg-sand pb12 pt6" />
      </div>

      {/* desktop */}
      <div className="container-xxl hidden md:grid md:grid-cols-4">
        <div className="BuyerAppQRModule__column-1">
          <SectionContent className="w-90-md w-70-lg white" />
        </div>
        <SmartImage
          wrapperOnlyClassName="BuyerAppQRModule__column-2 md:hidden lg:block"
          src={appMessengerImg}
          height="466px"
        />
        <div className="BuyerAppQRModule__column-3">
          <SmartImage
            Tag="div"
            src={appDesktopImg}
            className="w-100 h-100 bg-center cover"
          />
        </div>
      </div>
    </div>
  );
}
